import {useEffect} from 'react';

import {mountBrowserOtel, unmountBrowserOtel} from './utils';

// syncs with external browser OTEL lifecycle (provider, global listeners).
export const useBrowserOtelLifecycle = () => {
  useEffect(() => {
    mountBrowserOtel();

    return () => {
      unmountBrowserOtel();
    };
  }, []);
};
